import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import sendRequest from "../../../helpers/requestHelper";

const getCompanyUser = {
    namespaced: true,
    state: {
        dataReceive: {}
    },
    mutations: {
        GET_COMPANY_USER_SUCCESS(state, response) {
            if(!response.data || !response.data.address) {
                state.dataReceive = response.data.data;
                localStorage.setItem("companyLogo", response.data.data.logo);
            } else {
                state.dataReceive = response.data.data;
                localStorage.setItem("companyFirstName", state.dataReceive.firstName);
                localStorage.setItem("companyLastName", state.dataReceive.lastName);
                localStorage.setItem("companyName", state.dataReceive.companyName);
                localStorage.setItem("companyLogo", state.dataReceive.logo);
                localStorage.setItem("companyIsVatPayer", state.dataReceive.isVatPayer);
                eventBus.$emit("updateMyCompany");
            }
        },
        GET_COMPANY_USER_ERROR(state, error) {
            console.log(error);
        }
    },
    actions: {
        getCompanyUser({ dispatch }) {
            var promise = sendRequest("get", config.baseURLApi + "/user-company", {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetCompanyUser", result[1]);
                } else {
                    dispatch("errorGetCompanyUser", result[1]);
                }
                eventBus.$emit("setCompanyFormData");
            });
        },
        successGetCompanyUser({ commit }, response) {
            commit("GET_COMPANY_USER_SUCCESS", response);
        },
        errorGetCompanyUser({ commit }, error) {
            commit("GET_COMPANY_USER_ERROR", error);
        }
    }
}

export default getCompanyUser;
